export const labelableSelectedStyle = color => {
  return {
    borderColor: color,
    borderWidth: 0,
    boxShadow: `inset 0px 0px 0px 4px ${color}`
  };
};

export const labelableUnselectedStyle = color => {
  return {
    borderColor: color,
    borderWidth: 1,
    boxShadow: `inset 0px 0px 0px 0px ${color}`
  };
};

export const buttonSelectedStyle = color => {
  return {
    backgroundColor: color,
    filter: "brightness(100%)",
    // borderWidth: 0,
    // boxShadow: `inset 0px 0px 0px 4px white`
  };
};

export const buttonUnselectedStyle = color => {
  return {
    backgroundColor: color,
    filter: "brightness(100%)",
    // borderWidth: 0,
    // boxShadow: `inset 0px 0px 0px 0px ${color}`
  };
};
